export default __webpack_public_path__ + "static/media/2_SackOfGems.4bf5c3a6.png";